import { Button } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { toast } from "react-toastify";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SettingsIcon from "@mui/icons-material/Settings";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { baseUrl } from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const DeliveryManagement = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [data1, setData1] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [statusDelivery, setStatusDelivery] = useState("");
  const SuperAdmin = localStorage.getItem("is_superuser");
  const storeId = localStorage.getItem("store_id");

  const changedeliveryStatus = () => {
    SuperAdmin === "true"
      ? axios
        .put(
          `https://app1.crazzyhub.com/delivery_manager/delivery-preference/`,
          {
            delivery_option: statusDelivery,
          },
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((response) => {
          console.log(response?.data?.message);
          toast.success(response?.data?.success);
          getDeliveryPrefence();
          handleClose();
        })
        .catch((error) => {
          console.log("", error);
          toast.success(error?.data?.token);
        })
      : axios
        .put(
          `https://app1.crazzyhub.com/delivery_manager/delivery-preference/`,
          {
            store_id: storeId,
            delivery_option: statusDelivery,
          },
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((response) => {
          console.log(response?.data?.message);
          toast.success(response?.data?.success);
          getDeliveryPrefence();
          handleClose();
        })
        .catch((error) => {
          console.log("", error);
          toast.success(error?.data?.token);
        });
  };

  const getDeliveryPrefence = () => {
    axios
      .get(
        `https://storebh.bhaaraterp.com/delivery_manager/delivery-preference/`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.delivery_option);
        // console.log("preference data list===>",response?.data?.delivery_option)
      })
      .catch((error) => {
        console.log("", error);
        toast.success(error?.data?.token);
      });
  };

  const getDelivery_Prefence_Data = () => {
    axios
      .get(`${baseUrl}api/admin/delivery-setting-api/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        setData1(response?.data);
        // console.log("preference data list===>",response?.data?.delivery_option)
      })
      .catch((error) => {
        console.log("", error);
        toast.success(error?.data?.token);
      });
  };

  const AddDelivery_Prefence_Data = (value) => {
    axios
      .post(
        `${baseUrl}api/admin/delivery-setting-api/`,
        {
          delivery_partner: value,
        },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        getDelivery_Prefence_Data();
        toast.success(response?.data?.message);

        // console.log("preference data list===>",response?.data?.delivery_option)
      })
      .catch((error) => {
        console.log("", error);
        toast.success(error?.data?.token);
      });
  };

  useEffect(() => {
    getDelivery_Prefence_Data();
  }, []);

  return (
    <>
      <div className="">
        <div className="flex justify-between">
          <div className="p-2">
            <p className="text-xl text-black font-bold">Delivery Management</p>
          </div>
        </div>
        <div className="flex m-2">
          <div className="border border-gray-500 shadow-sm shadow-blue-900 p-2">
            <p className="text-center w-64 text-black font-bold">
              API Configuration
            </p>
            <div className="shadow-sm shadow-gray-400 flex justify-between cursor-pointer rounded text-black mt-4 p-1">
              <div className="flex justify-between">
                <div>
                  <Button
                    variant="text"
                    color="primary"
                    onClick={handleOpen}
                    size="small"
                  >
                    <SettingsIcon />
                    <span className="!px-2">Delivery Prefrence</span>
                  </Button>
                </div>
              </div>

              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} className="!border-0 !rounded-xl">
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h6"
                  >
                    <div
                      className="!text-center underline underline-offset-4"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      <div></div>
                    </div>
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <div className="gap-y-3"></div>
                    <div>
                      <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">
                          Delivery Prefrence
                        </FormLabel>
                        {/* <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue={data ? data : ""}
                          name="radio-buttons-group"
                          onChange={(event) =>
                            setStatusDelivery(event.target.value)
                          }
                        >
                          <FormControlLabel
                            value="Ship_Rocket"
                            control={<Radio />}
                            label="Ship Rocket"
                          />
                          <FormControlLabel
                            value="Porter"
                            control={<Radio />}
                            label="Porter"
                          />
                          <FormControlLabel
                            value="Bhaarat_Delivery"
                            control={<Radio />}
                            label="Bhaarat Delivery"
                          />
                        </RadioGroup> */}

                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          value={statusDelivery}
                          name="radio-buttons-group"
                          onChange={(event) =>
                            AddDelivery_Prefence_Data(event.target.value)
                          }
                        >
                          {data1?.data?.map((item) => (
                            <FormControlLabel
                              key={item.name}
                              value={item.name}
                              control={<Radio checked={item.active_status} />}
                              label={item.name.replace("_", " ")}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    </div>

                    <div className="justify-between items-center ">
                      <Button
                        className="float-left top-3"
                        variant="contained"
                        color="warning"
                        onClick={handleClose}
                      >
                        CANCEL
                      </Button>

                      <Button
                        variant="contained"
                        color="success"
                        className="float-right top-3 mr-3"
                        // onClick={changedeliveryStatus}

                        onClick={handleClose}
                      >
                        SAVE
                      </Button>
                    </div>
                  </Typography>
                </Box>
              </Modal>
            </div>

            <div
              className="shadow-sm shadow-gray-400 flex justify-between cursor-pointer rounded text-black w-44 mt-4 p-1"
              onClick={() => navigate("/delivery-management/ship-rocket")}
            >
              <div className="text-blue-500">Ship Rocket</div>
              <div>
                {" "}
                <ArrowForwardIcon className="!text-blue-500" />
              </div>
            </div>
            <div
              className="shadow-sm shadow-gray-400 flex cursor-pointer justify-between rounded text-black w-44 mt-4 p-1"
              onClick={() => navigate("/delivery-management/porter")}
            >
              <div className="text-blue-500">Porter</div>
              <div>
                {" "}
                <ArrowForwardIcon className="!text-blue-500" />
              </div>
            </div>
            <div
              className="shadow-sm shadow-gray-400 flex cursor-pointer justify-between rounded text-black w-44 mt-4 p-1"
              onClick={() => navigate("/bhaarat-delivery")}
            >
              <div className="text-blue-500">bhaarat delivery</div>
              <div>
                {" "}
                <ArrowForwardIcon className="!text-blue-500" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeliveryManagement;
